import { render, staticRenderFns } from "./QZJFBJ.vue?vue&type=template&id=40396ed8&scoped=true"
import script from "./QZJFBJ.vue?vue&type=script&lang=js"
export * from "./QZJFBJ.vue?vue&type=script&lang=js"
import style0 from "./QZJFBJ.vue?vue&type=style&index=0&id=40396ed8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40396ed8",
  null
  
)

export default component.exports